import type { SVGProps } from 'react';
const SvgBook = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.99088 5.19238H11.1962C12.4701 5.19238 13.6919 5.69847 14.5928 6.5993C15.4936 7.50014 15.9997 8.72194 15.9997 9.99591V26.8083C15.9997 25.8528 15.6201 24.9364 14.9445 24.2608C14.2689 23.5852 13.3525 23.2056 12.3971 23.2056H3.99088V5.19238Z"
      stroke="currentColor"
      stroke-width="1.92141"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.0088 5.19238H20.8035C19.5296 5.19238 18.3078 5.69847 17.4069 6.5993C16.5061 7.50014 16 8.72194 16 9.99591V26.8083C16 25.8528 16.3796 24.9364 17.0552 24.2608C17.7308 23.5852 18.6472 23.2056 19.6026 23.2056H28.0088V5.19238Z"
      stroke="currentColor"
      stroke-width="1.92141"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default SvgBook;
